import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';

import {authOperations} from '../redux/auth';
import {configOperations} from '../redux/config';

import AuthManager from '../esri/auth/AuthManager';

import Splash from './Splash';
import Login from './Login';
import Main from './Main';

import './App.css';

class App extends Component {
  componentWillMount() {
    this.props.fetchConfig();
  }

  componentWillReceiveProps(nextProps) {
    const wasLoaded = this.props.appConfig.loaded;
    const isLoaded = nextProps.appConfig && nextProps.appConfig.loaded;
    const authTried = nextProps.auth && nextProps.auth.loaded;

    if (!wasLoaded && isLoaded && !authTried) {
    window.authManager = new AuthManager(
      nextProps.appConfig,
      nextProps.appConfig.portalUrl,
      nextProps.appConfig.jsapiUrl,
      nextProps.appConfig.jsapiV4,
      nextProps.appConfig.loginWithPopup
    );
    // window.authManager = new AuthManager(
    //   nextProps.appConfig[nextProps.appConfig.env],
    //   nextProps.appConfig.portalUrl,
    //   nextProps.appConfig.jsapiUrl,
    //   nextProps.appConfig.jsapiV4,
    //   nextProps.appConfig.loginWithPopup
    // );
    window.authManager.startup().then(nextProps.checkAuth);
    }
  }

  render() {
    // We'll use these to determine what state the app is in
    const configLoaded = this.props.appConfig.loaded;
    const authTried = this.props.auth.loaded;
    const isAuthenticated =
      this.props.auth.user && this.props.auth.user.username;

    // Three possible states:
    //  1. App is initializing --> show splash component
    //  2. User is not logged in --> show login component
    //  3. User is logged in --> show Main component

    //
    // 1. App is initializing
    //
    if (!configLoaded || !authTried) {
      return <Splash/>;
    }
    //
    // 2. User is not logged in
    //
    if (!isAuthenticated) {
      return (
        <div style={{height: '100%'}}>
          <Route path="/" component={Login}/>
        </div>
      );
    }
    //
    // 3. User is logged in
    //
    return <Route path="/" component={Main}/>;
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  appConfig: state.config
});

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(
    {
      ...configOperations,
      ...authOperations
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js